/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Referrals_Page_Meta_TitleInputs */

const en_referrals_page_meta_title = /** @type {(inputs: Referrals_Page_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Refer & Earn | Glider`)
};

const de_referrals_page_meta_title = /** @type {(inputs: Referrals_Page_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Empfehlen und verdienen | Glider`)
};

const pt_br2_referrals_page_meta_title = /** @type {(inputs: Referrals_Page_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Indique e ganhe | Glider`)
};

const tr_referrals_page_meta_title = /** @type {(inputs: Referrals_Page_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Davet Et ve Kazan | Glider`)
};

const zh_cn2_referrals_page_meta_title = /** @type {(inputs: Referrals_Page_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`邀请赚奖励 | Glider`)
};

const zh_hk2_referrals_page_meta_title = /** @type {(inputs: Referrals_Page_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`推薦賺獎賞 | Glider`)
};

const ko_kr2_referrals_page_meta_title = /** @type {(inputs: Referrals_Page_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`추천하고 리워드 받기 | Glider`)
};

const ru_ru2_referrals_page_meta_title = /** @type {(inputs: Referrals_Page_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Приглашайте и зарабатывайте | Glider`)
};

const es_419_referrals_page_meta_title = /** @type {(inputs: Referrals_Page_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Refiere y gana | Glider`)
};

/**
* | output |
* | --- |
* | "Refer & Earn \| Glider" |
*
* @param {Referrals_Page_Meta_TitleInputs} inputs
* @param {{ locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }} options
* @returns {LocalizedString}
*/
export const referrals_page_meta_title = /** @type {((inputs?: Referrals_Page_Meta_TitleInputs, options?: { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Referrals_Page_Meta_TitleInputs, { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_referrals_page_meta_title(inputs)
	if (locale === "de") return de_referrals_page_meta_title(inputs)
	if (locale === "pt-BR") return pt_br2_referrals_page_meta_title(inputs)
	if (locale === "tr") return tr_referrals_page_meta_title(inputs)
	if (locale === "zh-CN") return zh_cn2_referrals_page_meta_title(inputs)
	if (locale === "zh-HK") return zh_hk2_referrals_page_meta_title(inputs)
	if (locale === "ko-KR") return ko_kr2_referrals_page_meta_title(inputs)
	if (locale === "ru-RU") return ru_ru2_referrals_page_meta_title(inputs)
	return es_419_referrals_page_meta_title(inputs)
});